/* Bridella Wishlist (complete) */
(() => {
  const PROXY_BASE = '/apps/wishlist';
  const BTN_SEL = '[data-br-wishlist]';
  const loggedIn = !!window.__CUSTOMER_ID__;

  /* ---------- Modal helpers ---------- */
  const $modal = document.getElementById('fave-auth-modal');
  const $login = document.getElementById('fave-login-btn');
  const $guest = document.getElementById('fave-guest-btn'); // intentionally hidden in CSS/markup
  const $close = document.getElementById('fave-close');

  const openAuth = () => {
    if (!$modal) return;
    $modal.hidden = false;
    document.body.style.overflow = 'hidden';
  };
  const closeAuth = () => {
    if (!$modal) return;
    $modal.hidden = true;
    document.body.style.overflow = '';
  };

  $login && $login.addEventListener('click', () => {
    const ret = location.pathname + location.search + location.hash;
    location.href = '/account/login?return_url=' + encodeURIComponent(ret);
  });
  $guest && $guest.addEventListener('click', closeAuth);
  $close && $close.addEventListener('click', closeAuth);
  $modal && $modal.addEventListener('click', (e) => {
    if (e.target === $modal) closeAuth();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && $modal && !$modal.hidden) closeAuth();
  });

  /* ---------- UI helpers ---------- */
  function mark(btn, liked) {
    if (!btn) return;
    btn.classList.toggle('is-active', !!liked);
    btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
  }
  function getHandle(btn) {
    return btn?.getAttribute('data-fave-handle') || '';
  }

  /* ---------- Network helpers ---------- */
  function normalizeAfterToggle(resp, prevLiked) {
    try {
      const j = resp || {};
      const status = String(j.status ?? '').toLowerCase();
      if (['removed', 'deleted', 'off', 'false'].includes(status)) return false;
      if (['added', 'created', 'ok', 'true'].includes(status)) return true;
      if (typeof j.favorite !== 'undefined') return !!j.favorite;
      if (typeof j.fav !== 'undefined') return !!j.fav;
      if (typeof j.liked !== 'undefined') return !!j.liked;
      if (typeof j.result !== 'undefined') return !!j.result;
      if (typeof j.ok !== 'undefined') return j.ok ? !prevLiked : prevLiked
      // Fallback: keep previous if unknown
      return !!prevLiked;
    } catch {
      return !!prevLiked;
    }
  }

  async function toggle(handle, prevLiked) {
    const res = await fetch(`${PROXY_BASE}/toggle?handle=${encodeURIComponent(handle)}`, {
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error(`toggle ${res.status}`);
    const j = await res.json().catch(() => ({}));
    return normalizeAfterToggle(j, prevLiked);
  }

  async function fetchStatusFor(handles) {
    // Best-effort status endpoint; harmless if not implemented by backend.
    try {
      const url = `${PROXY_BASE}/status?handles=${encodeURIComponent(handles.join(','))}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return new Set();
      const j = await res.json();

      // Accept several shapes
      let list = [];
      if (Array.isArray(j)) list = j;
      else if (Array.isArray(j.favorites)) list = j.favorites;
      else if (Array.isArray(j.handles)) list = j.handles;
      else if (Array.isArray(j.items)) list = j.items.map(x => x.handle || x);
      else if (Array.isArray(j.data)) list = j.data.map(x => x.handle || x);

      return new Set(list.map(String));
    } catch {
      return new Set();
    }
  }

  /* ---------- Click handling (single delegate) ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(BTN_SEL);
    if (!btn) return;

    // prevent card navigation
    e.preventDefault();
    e.stopPropagation();

    if (!loggedIn) {
      openAuth();
      return;
    }

    const handle = getHandle(btn);
    if (!handle || btn.disabled) return;

    const wasPressed = btn.getAttribute('aria-pressed') === 'true';
    btn.disabled = true;

    try {
      const liked = await toggle(handle, wasPressed);
      mark(btn, liked);
    } catch (err) {
      console.error('Wishlist toggle failed:', err);
    } finally {
      btn.disabled = false;
    }
  });

  /* ---------- Initial state sync ---------- */
  async function initState(scope = document) {
    if (!loggedIn) return;
    const buttons = Array.from(scope.querySelectorAll(BTN_SEL));
    if (!buttons.length) return;

    const handles = Array.from(new Set(buttons.map(getHandle).filter(Boolean)));
    if (!handles.length) return;

    const likedSet = await fetchStatusFor(handles);
    buttons.forEach((b) => mark(b, likedSet.has(getHandle(b))));
  }

  // First pass
  initState();

  // Observe newly inserted hearts (sections load, quick view, infinite scroll)
  const mo = new MutationObserver((muts) => {
    let needs = false;
    muts.forEach((m) => {
      if (m.addedNodes && m.addedNodes.length) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches?.(BTN_SEL) || n.querySelector?.(BTN_SEL))) {
            needs = true;
            break;
          }
        }
      }
    });
    if (needs) initState();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
